export const btoaEscape = (val: string) => btoa(encodeURIComponent(val));
export const atobUnescape = (val: string) => decodeURIComponent(atob(val));
export const identity = <T>(arg: T) => arg;
